import { useEffect, useState } from "react";

const useWagerWire = () => {
  const [wagerWireClosed, setWagerWireClosed] = useState(false);

  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event.origin !== process.env.REACT_APP_WAGER_WIRE_EMBED_ORIGIN) {
        return; // Ignore messages from other origins
      }

      if (event.data === "refresh") {
        setWagerWireClosed(true);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    wagerWireClosed,
    setWagerWireClosed,
  };
};

export default useWagerWire;
